import angular from "angular"

import client from "@/client.js"
import Auth from "@/auth.js"
import {
  configureIdentityTokenRefresh,
  resetIdentityTokenRefresh
} from "@/identity-token-refresh.js"

/**
 * Main service to control the authentication of the user.
 */
const factory = [
  "$rootScope",
  "store",
  "$state",
  "$http",
  "apiService",
  function($rootScope, store, $state, $http, apiService) {
    /**
     * Shows an Auth0 popup to login a user. If the user is correctly
     * logged in, his profile and token returned by Auth0 is stored using
     * localStorage.
     */
    var api_auth_url = apiService.api_auth_url

    $rootScope.$on("unauthenticated", function() {
      console.log("$on:unauthenticated")
      logout()
    })

    /**
     * Re-applies the stored JWT to $http defaults when the app boots.
     * Memory is cleared on refresh, so without this REST calls miss Authorization
     * when the API hostname is not in jwtInterceptor whiteListedDomains.
     */
    function restoreSession() {
      applyTokenToHttp(getToken())
    }

    function applyTokenToHttp(token) {
      $http.defaults.headers.common.Authorization = token ? "JWT " + token : ""
    }

    function goAfterLogin() {
      try {
        var role = store.get("user").rol
        switch (role) {
          case "EDITOR ATENCIONES MASIVAS":
            $state.go("app.estudiantes")
            break
          default:
            $state.go("app.home")
            break
        }
      } catch (err) {
        console.log(err)
        $state.go("app.home")
      }
    }

    function login(username, password, callback) {
      $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: apiService.baseUrl + api_auth_url,
        data: JSON.stringify({ username: username, password: password })
      })
        .then(function(response) {
          var token = response.data.token
          store.set("user", response.data.user)
          store.set("token", token)
          applyTokenToHttp(token)
          resetIdentityTokenRefresh()
          goAfterLogin()
        })
        .catch(function() {
          console.log("an error...")
          callback()
        })
    }

    function getRedirectUrl(callback) {
      const currentUrl = window.location.origin

      $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: apiService.baseUrl + "api/identity/get-auth-method",
        params: {
          redirectUrl: currentUrl
        }
      }).then(function(response) {
        localStorage.setItem("auth_method", response.data.authMethod || "legacy")
        callback(response.data.redirectUrl)
      })
    }

    function validateToken(accessToken, callback) {
      $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "JWT " + accessToken
        },
        url: apiService.baseUrl + "api/identity/validate-token"
      })
        .then(function(response) {
          store.set("user", response.data.user)
          store.set("token", accessToken)
          applyTokenToHttp(accessToken)
          resetIdentityTokenRefresh()
        })
        .then(responses => {
          // When both logins succeed, go to home
          try {
            var role = store.get("user").rol
            switch (role) {
              case "EDITOR ATENCIONES MASIVAS":
                $state.go("app.estudiantes")
                break
              default:
                $state.go("app.home")
                break
            }
          } catch (err) {
            console.log(err)
            $state.go("app.home")
          }
        })
        .catch(responses => {
          console.log("an error...")
          callback()
        })
    }

    /**
     * Removes token and profile information from localStorage and redirects to
     * the home.
     */
    function logout() {
      var hadSession = Boolean(store.get("token"))

      store.remove("user")
      store.remove("token")
      store.remove("periodo_activo")
      applyTokenToHttp(null)

      Auth.onLogout()

      if (hadSession) {
        client.resetStore().catch(function(error) {
          console.debug("Apollo store reset failed during logout", error)
        })
      }

      $state.go("login")
    }

    /**
     * Obtains the token of the user logged in.
     * @return {string} User token.
     */
    function getToken() {
      return store.get("token")
    }

    function getUser() {
      var user = store.get("user")
      if (!user) {
        logout()
        return
      }
      var temp = user.full_name

      return temp.trim() === "" ? user.username : temp
    }

    configureIdentityTokenRefresh({
      updateToken: function(token) {
        store.set("token", token)
        applyTokenToHttp(token)
      },
      logout: logout
    })

    return {
      login: login,
      logout: logout,
      getToken: getToken,
      getUser: getUser,
      getRedirectUrl: getRedirectUrl,
      validateToken: validateToken,
      restoreSession: restoreSession,
      applyTokenToHttp: applyTokenToHttp
    }
  }
]

angular.module("appModule").factory("loginService", factory)
